import com.essntl.features.notification.domain.model.NotificationModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class NotificationDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    val title: String,
    val body: String,
    @SerialName("chat_id")
    val chatId: String?,
    val timestamp: String?,
    val type: String,
) {
    fun toModel(): NotificationModel =
        NotificationModel(
            id = id,
            createdAt = createdAt,
            title = title,
            body = body,
            chatId = chatId,
            timestamp = timestamp,
            type = when (type) {
                "WHATSAPP" -> NotificationModel.NotificationType.Whatsapp
                "WHATSAPP_CALL" -> NotificationModel.NotificationType.WhatsappCall
                else -> null
            }
        )
}